import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin, Alert } from 'antd';
import { useAuth } from '../contexts/AuthContext';

export interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false,
}) => {
  const { currentUser, isApproved, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isApproved) {
    return (
      <div style={{ padding: 50, textAlign: 'center' }}>
        <Alert
          message="等待審核"
          description="您的帳戶正在等待管理員審核，審核通過後即可使用所有功能。"
          type="warning"
          showIcon
        />
      </div>
    );
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div style={{ padding: 50, textAlign: 'center' }}>
        <Alert
          message="權限不足"
          description="您沒有訪問此頁面的權限。"
          type="error"
          showIcon
        />
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
